"use client";

import React from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function MasterYourLoft() {
  return <section data-section-id="240232" id="the-future-of-hospitality" className="bg-background text-foreground relative overflow-hidden h-[400px] md:h-[550px] flex items-center py-12 md:py-16 bg-cover bg-center bg-[linear-gradient(rgba(0,0,0,0.1),rgba(0,0,0,0.2))] lg:py-20 !bg-[url(https://accurate-cicada.10web.cloud/wp-content/uploads/2026/05/header-foto-scaled.jpg)]">
      <style dangerouslySetInnerHTML={{
      __html: `
            @keyframes scrollGrid {
              0% { background-position: 0 0; }
              100% { background-position: 0 4rem; }
            }
            .animate-scroll-grid {
              animation: scrollGrid 4s linear infinite;
            }
            @keyframes levitate {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-20px); }
            }
            .animate-levitate {
              animation: levitate 6s ease-in-out infinite;
            }
          `
    }} />

      <div className="absolute inset-0 z-5 pointer-events-none bg-gradient-to-r from-background/40 via-background/10 to-transparent" />

      <div className="absolute inset-0 z-0 pointer-events-none flex justify-center">
        <div className="absolute inset-0 opacity-[0.02] animate-scroll-grid flex items-center justify-center overflow-hidden">
          <span className="text-[25vw] font-black font-default uppercase tracking-tighter text-white select-none">
            HAVEN
          </span>
        </div>

        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,var(--color-primary)_0%,transparent_50%)] opacity-10 mix-blend-screen" />
      </div>

      <div className="container mx-auto px-6 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="flex flex-col gap-6 md:gap-8 max-w-2xl">
            <div className="space-y-4">
              <h1 className="font-black tracking-tighter uppercase leading-[0.95] text-4xl !text-[rgba(14,40,47,1)] [word-spacing:0.25em] !font-default md:text-6xl"><span className="!font-default">DE KRACHT ACHTER STERKERE HORECA</span> </h1>
              <p className="text-lg font-default max-w-lg leading-relaxed text-primary-foreground !font-semibold md:text-xl">Jouw externe hoofdkantoor<br />voor grip, groei en rendement.</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2 md:pt-4">
              <Button size="lg" className="h-14 px-8 text-base md:text-lg font-semibold bg-primary text-primary-foreground hover:shadow-[0_0_50px_rgba(168,85,247,0.75)] transition-shadow duration-300 rounded-lg" asChild>
                <Link to="https://forms.monday.com/forms/fb496b700d17ce22e3514fb71ddd4471?r=euc1" target="_blank" rel="noopener noreferrer">Plan vrijblijvend gesprek<ArrowRight className="ml-2 size-5" /></Link>
              </Button>
              <Button size="lg" variant="outline" className="h-14 px-8 text-base md:text-lg font-semibold border-border text-foreground hover:bg-accent hover:text-accent-foreground transition-colors duration-300 rounded-lg" asChild>
                <Link to="/OurApproachPage">Bekijk onze aanpak</Link>
              </Button>
            </div>
          </div>

          
        </div>
      </div>
    </section>;
}